<template>

  <v-card>

    <!-- barra y botonera del paso -->
    <v-toolbar color="white" flat>
      <v-btn icon light>
        <v-icon color="grey darken-2">mdi-domain</v-icon>
      </v-btn>
      <v-toolbar-title class="grey--text text--darken-4">
        {{$t('empresaCliente')}}
        <p class="caption">{{$t('seleccionEmpresaCliente')}}</p>
      </v-toolbar-title>
      <div v-show="dShowLoading" id="loading" style="margin-left:50px;margin-top:-10px;z-index:99999">
        <div style="display: inline-block;">
          <cube-spin class="loadingStyle"></cube-spin>
        </div>
        <div style="display: inline-block;color:#43a047;margin-left:10px;margin-top:-50px">
          <span class="caption">{{$t('procesando')}}...</span>
        </div>
      </div>
      <v-spacer></v-spacer>
      <v-btn color="green darken-1  white--text" value="continuar" @click="fGuardaContinuar()">
        <span>{{$t('continuar')}}</span>
        <v-icon>mdi-arrow-right</v-icon>
      </v-btn>
    </v-toolbar>

    <!-- formulario con los datos -->
    <v-card-text>
      <v-form v-model="dValidacionPaso1" ref="form" lazy-validation>
        <v-container fluid>
          <v-layout row wrap>
            <v-flex xs12 md6 px-3>
              <DatTextFieldCode ref="TextClient" :pDataPass="dDataClient" @select="fSelectClient" @clean="fClearClient" @alert="fAlert"></DatTextFieldCode>
            </v-flex>
            <v-flex xs12 md6 px-3>
              <DatTextFieldCode  ref="TextSucursal" :pDataPass="dDataSucursal"  @select="fSelectSucursal" @clean="fClearSucursal" @alert="fAlert"></DatTextFieldCode>
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>
    </v-card-text>

    <div style="flex: 1 1 auto;"></div>

  </v-card>

</template>

<script>
import DatTextFieldCode from '@/components_datadec/DatTextFieldCode'
import CubeSpin from 'vue-loading-spinner/src/components/Jumper'

export default {
  name: 'ShpAsistentePaso1',
  props: {
    pPresupuestoAsistente: {
      type: Object,
      required: true
    },
    pEsNuevo: {
      type: Boolean,
      required: true
    }
  },
  components: {
    DatTextFieldCode,
    CubeSpin
  },
  data () {
    return {
      dDisabled: true,
      dRowsPerPageArray: [5, 15, 25, 50],
      dRowsPerPage: 5,
      dShowLoading: !this.pEsNuevo,
      dPresupuestoAsistentePaso1: this.pPresupuestoAsistente,
      dValidacionPaso1: true,
      dSelectCliente: {},
      dSelectSucursal: {},
      dRequestCliente: {empresa: this.$store.getters.getAutenticacion.empresa},
      dDataClient: {},
      dDataSucursal: {}
    }
  },
  created () {
    this.fIniciarVariables()
  },
  methods: {
    fIniciarVariables () {
      this.dDataClient = {
        'errorMessages': [],
        'label': 'clienteInicial',
        'rowsPerPage': this.dRowsPerPage,
        'headers': [
          { text: this.$t('cliente'), align: 'left', value: 'codigo', column: 'cliente' },
          { text: this.$t('nombreCliente'), align: 'left', value: 'nombre', column: 'nombre' }
        ],
        'urlWS': 'lovClte',

        'item': {'codigo': '', 'nombre': ''},
        'filters': {'codigo': 'cliente', 'nombre': 'nombre'},
        'resultName': 'dataRes',
        'request': this.dRequestCliente,
        'default': this.dSelectCliente,
        'disabled': false,
        'required': false,
        'orderByDefault': 'cliente',
        'orderDefault': 'ASC',
        'isVisibleLoad': true,
        'textCodigo': 'codigo',
        'title': 'seleccionaUnCliente'
      }

      this.dDataSucursal = {
        'errorMessages': [],
        'label': this.$t('sucursal'),
        'rowsPerPage': 10,
        'headers': [
          { text: this.$t('sucursal'), align: 'left', value: 'codigo', column: 'sucursal' },
          { text: this.$t('nombreSucursal'), align: 'left', value: 'nombre', column: 'razonSocial' }
        ],
        'urlWS': 'lovDic',

        'item': {'codigo': '', 'nombre': ''},
        'filters': {'codigo': 'sucursal', 'nombre': 'razonSocial'},
        'resultName': 'dataRes',
        'request': null,
        'default': this.dSelectSucursal,
        'disabled': true,
        'required': true,
        'orderByDefault': 'sucursal',
        'orderDefault': 'sucursal',
        'isVisibleLoad': true,
        'textCodigo': 'codigo',
        'title': this.$t('seleccionaUnaSucursal'),
        'client': this.dSelectCliente.codigo
      }
    },
    fAlert (msg) {
      this.$emit('alert', msg)
    },
    fSelectClient (item) {
      const clientAnt = this.dPresupuestoAsistentePaso1.cliente

      this.dSelectCliente = {
        codigo: item.codigo,
        nombre: item.nombre
      }
      // Si cambia el cliente
      if (clientAnt !== item.codigo) {
        this.dPresupuestoAsistentePaso1.cliente = item.codigo
        this.dPresupuestoAsistentePaso1.nombreCliente = item.nombre
        if(item.codigo !== '' && item.codigo !== undefined){
          this.$refs.TextSucursal.fChangeDisabled(false)
        }
        this.dDataSucursal.client = item.codigo
        this.dDataSucursal.request = {
          empresa: this.$store.getters.getAutenticacion.empresa,
          cliente: item.codigo
        }
        if(item.codigo !== '' && item.codigo !== undefined){
          this.$emit('newId', item.codigo)
        }
      }
    },
    fClearClient () {
      this.$refs.TextSucursal.fChangeDisabled(true)
      this.dPresupuestoAsistentePaso1.cliente = ''
      this.dPresupuestoAsistentePaso1.nombreCliente = ''
      this.fClearSucursal()
      this.dDataSucursal.disabled = true
      
      this.$refs.TextSucursal.fClear()
      this.dSelectCliente = {}
    },
    fSelectSucursal (item) {
      this.dPresupuestoAsistentePaso1.sucursalEnvio = item.codigo
      this.dPresupuestoAsistentePaso1.razonSocial = item.nombre
      this.dSelectSucursal = {
        codigo: item.codigo,
        nombre: item.nombre
      }

    },
    fClearSucursal () {
      this.dPresupuestoAsistentePaso1.sucursalEnvio = ''
      this.dPresupuestoAsistentePaso1.razonSocial = ''
      this.dSelectSucursal = {}
    },
    fCargarDefault (presupuesto) {
      this.dShowLoading = true
      this.dPresupuestoAsistentePaso1 = presupuesto
      this.dSelectCliente = {
        codigo: this.dPresupuestoAsistentePaso1.cliente,
        nombre: this.dPresupuestoAsistentePaso1.razonSocial
      }
      if (this.dPresupuestoAsistentePaso1.sucursalEnvio !== null) {
        this.dSelectSucursal = {
          codigo: this.dPresupuestoAsistentePaso1.sucursalEnvio,
          nombre: this.dPresupuestoAsistentePaso1.razonSocial
        }
      }
      this.dShowLoading = false
      this.$refs.TextClient.fRecargarValores(this.dSelectCliente)
      this.$refs.TextSucursal.fRecargarValores(this.dSelectSucursal)
    },
    fGuardaContinuar () {
      // hace los chequeos necesarios
      if (this.fCheckFilters()) {
        this.$emit('save', this.dPresupuestoAsistentePaso1)
      } else {
        this.$emit('alert', '<b>' + this.$t('filtersAlert') + '</b><br/>' + this.$t('filtersClientSuc'))
      }
    },
    fCheckFilters () {
      return (this.dSelectCliente.codigo !== undefined && this.dSelectCliente.codigo !== '' && this.dSelectSucursal.codigo !== undefined && this.dSelectSucursal.codigo !== '')
    },
    fDisableCliente () {
      return (!this.pEsNuevo)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style >
.loadingStyle.spinner > div[data-v-def4b4ac] {
  background-color: #43a047 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Informes/Presupuestos/ShpAsistentePaso1.vue